import 'css-chunksrc/client/pages/zonesPage/zonesPage/loader/styles.scss';export default {
  "loader": "_loader_1hcgt_1",
  "item": "_item_1hcgt_8"
};